<template>
  <vs-popup
    fullscreen
    :title="`Kode dan Laporan Qurban ${passData.name}`"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <div class="vx-row justify-between mt-2 w-full">
      <section class="vx-col lg:w-2/5 sm:w-full">
        <header class="w-full">
          <div class="mb-base vx-row justify-between items-top">
            <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start"
            >
              <span class="text-black text-xl"><strong>Tabel Kode Qurban</strong></span>
            </section>
            <!-- <section
              class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
            >
              <vs-button @click="openPopUp(null)" v-if="access.create === 1"
                >Tambah Kategori Campaign</vs-button
              >
            </section> -->
          </div>
          <!-- <div class="vx-row justify-between items-center">
            <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
              <div class="w-full gap-2 flex justify-start items-center">
                <vs-button @click="actionsDelete">{{
                  selected.length === 0 ? "Hapus" : `Hapus ${selected.length} Item`
                }}</vs-button> -->
          <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <vs-button icon-after icon="expand_more">Aksi</vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="dialogDelete">
                      <span>Hapus</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">{{ `entries ${limit}` }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      v-for="(item, index) in limitDataTables"
                      :key="index"
                      @click="limit = item"
                    >
                      <span>{{ item }}</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown> -->
          <!-- </div>
            </section>
            <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
              <div class="w-full flex justify-end gap-2 flex-wrap items-center">
                <vs-input v-model="search" placeholder="Search..." />
              </div>
            </section>
          </div> -->

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div
            class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
          ></div>
        </header>

        <main ref="loadKodeQurban">
          <vs-table stripe :data="passData.kode_qurban" :max-items="7" pagination>
            <template slot="thead">
              <vs-th>Kode</vs-th>
              <vs-th>Aksi</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].kode">
                  {{ data[indextr].kode }}
                </vs-td>
                <vs-td>
                  <vs-button
                    :color="itemEdit === data[indextr] ? '#FF0000' : '#045532'"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-file-text"
                    @click="itemEdit = data[indextr]"
                  >
                    Laporan
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </main>
      </section>

      <section class="vx-col lg:w-3/5 sm:w-full">
        <div v-if="itemEdit !== null">
          <main>
            <div></div>
            <div class="flex justify-between mb-5">
              <span class="text-black text-xl overflow-visible"
                ><strong>{{ `Laporan ${itemEdit.kode}` }}</strong></span
              >
              <vs-icon
                class="cursor-pointer"
                icon="clear"
                size="medium"
                color="#383838"
                @click="itemEdit = null"
              ></vs-icon>
            </div>
            <vs-collapse class="mb-4" accordion type="border" :open="idLaporan !== null">
              <vs-collapse-item>
                <div slot="header">
                  <div class="flex justify-between items-center">
                    <strong class="truncate">{{
                      idLaporan === null
                        ? "Buat Laporan"
                        : `Update Laporan ${formData.name}`
                    }}</strong>
                    <vs-icon
                      v-if="idLaporan !== null"
                      class="cursor-pointer mr-5"
                      icon="clear"
                      size="small"
                      color="#383838"
                      @click="closeEdit()"
                    ></vs-icon>
                  </div>
                </div>
                <main class="w-full">
                  <!-- <div class="mb-6">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Kode Qurban</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <vs-input
                v-validate="'required'"
                data-vv-validate-on="blur"
                name="name"
                :disabled="true"
                class="w-full sidebar-input"
                v-model="itemEdit.id"
                placeholder="Isi Dengan Nama Syarat"
              />
              <span class="text-danger text-sm">{{ errors.first("name") }}</span>
            </div> -->
                  <div class="mb-base">
                    <img
                      :src="
                        formData.file !== null
                          ? formData.file.includes('upload//')
                            ? `${url.baseFl}/${formData.file}`
                            : formData.file
                          : formData.file
                      "
                      alt="laporan-img"
                      class="rounded-lg w-full cover-hight shadow-md cursor-pointer mb-4"
                    />
                    <div class="vx-row w-full justify-between items-start">
                      <div class="vx-col sm:w-full lg:w-1/2 xl:w-1/2 flex justify-start">
                        <input
                          type="file"
                          class="hidden"
                          ref="updateImgInput"
                          @change="updateCurrImg"
                          accept="image/*"
                        />
                        <div class="flex justify-start gap-4">
                          <vs-button
                            class="sm:mb-0 mb-2"
                            @click="$refs.updateImgInput.click()"
                            >Upload File Laporan</vs-button
                          >
                          <vs-button
                            v-if="formData.file !== emptyImage"
                            color="danger"
                            type="filled"
                            icon="clear"
                            @click="formData.file = emptyImage"
                          ></vs-button>
                        </div>
                        <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
                      </div>
                      <!-- <div class="vx-col sm:w-full lg:w-1/2 xl:w-1/2 flex justify-end">
            <p class="text-red">Ukuran Rekomendasi : 1365 x 404</p>
          </div> -->
                    </div>
                  </div>
                  <div class="mb-6">
                    <section class="mb-4 flex justify-start gap-1">
                      <h6><strong>Kode Qurban</strong></h6>
                      <span class="text-danger">*</span>
                    </section>
                    <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      name="qurban code"
                      :disabled="true"
                      class="w-full sidebar-input"
                      v-model="itemEdit.kode"
                      placeholder="Isi Dengan Kode Qurban"
                    />
                    <span class="text-danger text-sm">{{
                      errors.first("qurban code")
                    }}</span>
                  </div>
                  <div class="mb-6">
                    <section class="mb-4 flex justify-start gap-1">
                      <h6><strong>Judul</strong></h6>
                      <span class="text-danger">*</span>
                    </section>
                    <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      name="title"
                      class="w-full sidebar-input"
                      v-model="formData.name"
                      placeholder="Isi Dengan Judul Laporan"
                    />
                    <span class="text-danger text-sm">{{ errors.first("title") }}</span>
                  </div>
                  <div class="mb-6">
                    <section class="mb-4 flex justify-start gap-1">
                      <h6><strong>Isi Berita</strong></h6>
                      <span class="text-danger">*</span>
                    </section>
                    <!-- <vs-button
                      class="sm:mb-0 mb-2"
                      @click="formData.description = formatLaporan"
                      >Generate Format Laporan</vs-button
                    > -->
                    <vue-editor
                      class="w-full"
                      v-model="formData.description"
                      name="description"
                      v-validate="'required'"
                    ></vue-editor>
                    <span class="text-danger text-sm">{{
                      errors.first("description")
                    }}</span>
                  </div>
                </main>
                <footer class="mt-4">
                  <div class="flex justify-end items-center mr-4 mb-4">
                    <vs-button
                      color="success"
                      class="ml-2 rounded-2xl"
                      :disabled="!validateForm"
                      @click="addWithOption()"
                      >{{ labelButton }}</vs-button
                    >
                  </div>
                </footer>
              </vs-collapse-item>
            </vs-collapse>
            <header class="w-full">
              <!-- <div class="mb-base mt-4 vx-row justify-between items-top">
                <section
                  class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start"
                >
                  
                </section>
              </div> -->
              <div class="vx-row justify-between items-center">
                <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
                  <div class="w-full gap-2 flex justify-start items-center">
                    <span class="text-black text-xl"><strong>Tabel Laporan</strong></span>
                    <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <vs-button icon-after icon="expand_more">Aksi</vs-button>
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="dialogDelete">
                          <span>Hapus</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">{{ `entries ${limit}` }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                      </div>
                      <vs-dropdown-menu>
                        <vs-dropdown-item
                          v-for="(item, index) in limitDataTables"
                          :key="index"
                          @click="limit = item"
                        >
                          <span>{{ item }}</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown> -->
                  </div>
                </section>
                <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
                  <div class="w-full flex justify-end gap-2 flex-wrap items-center">
                    <vs-input v-model="search" placeholder="Search..." />
                  </div>
                </section>
              </div>

              <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
              <div
                class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
              ></div>
            </header>

            <main ref="loadLaporanQurban">
              <vs-table
                stripe
                :data="laporans"
                v-model="selected"
                :max-items="5"
                pagination
              >
                <template slot="thead">
                  <vs-th>Foto</vs-th>
                  <vs-th>Judul</vs-th>
                  <vs-th>Tgl. Laporan</vs-th>
                  <vs-th>Aksi</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].file">
                      <img
                        key="indextr"
                        :src="
                          data[indextr].file
                            ? data[indextr].file.includes('http')
                              ? data[indextr].file
                              : `${url.baseFl}/${data[indextr].file}`
                            : emptyImage
                        "
                        alt="user-img"
                        class="rounded-lg imgTbl shadow-md cursor-pointer block"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                    <vs-td :data="data[indextr].updated_at">
                      {{ data[indextr].updated_at.replaceAll("T", " ").split(".000000Z")[0], }}
                    </vs-td>
                    <vs-td>
                      <div
                        class="flex justify-start gap-2"
                        v-if="itemDelete !== data[indextr].id"
                      >
                        <vs-tooltip text="Edit">
                          <vs-button
                            color="primary"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-edit"
                            @click="openEdit(data[indextr])"
                          >
                          </vs-button>
                        </vs-tooltip>
                        <vs-tooltip text="Delete">
                          <vs-button
                            color="danger"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-trash"
                            @click="itemDelete = data[indextr].id"
                          >
                          </vs-button>
                        </vs-tooltip>
                      </div>
                      <div class="flex justify-start gap-2" v-else>
                        <vs-button
                          color="danger"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-trash"
                          @click="deleteItem(data[indextr].id)"
                        >
                          Delete
                        </vs-button>
                        <vs-button
                          color="#949494"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-x"
                          @click="itemDelete = null"
                        >
                          No
                        </vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </main>
            <!-- <footer>
              <div class="justify-end mt-2">
                <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
              </div>
            </footer> -->
          </main>
          <!-- <footer class="mt-4">
            <div class="flex justify-end items-center mr-4 mb-4"> -->
          <!-- <vs-button
          color="danger"
          class="mr-2 rounded-2xl"
          @click="closeWithLoad(false)"
          >Cancel</vs-button
        > -->
          <!-- <vs-button
                :color="itemEdit === null ? 'success' : 'warning'"
                class="ml-2 rounded-2xl"
                :disabled="!validateForm"
                @click="addData"
                >{{ labelButton }}</vs-button
              >
            </div>
          </footer> -->
        </div>
        <div v-else>
          <center class="w-full break-words">
            <strong class="text-lg text-black"
              >Pilih salah satu kode qurban untuk melakukan laporan</strong
            >
          </center>
        </div>
      </section>
    </div>
  </vs-popup>
</template>

<script>
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";
import { VueEditor } from "vue2-editor";

export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  components: {
    VueEditor,
  },
  data() {
    return {
      params: {},
      emptyImage,
      url,
      limit: limitDataTables[0],
      active: false,
      laporanList: [],
      binaryFile: "",
      itemEdit: null,
      itemDelete: null,
      selected: [],
      access: null,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      search: "",
      idLaporan: null,
      formData: {
        kode_id: "",
        name: "",
        description: "",
        file: emptyImage,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.idLaporan != null ? "Edit Laporan" : "Tambah Laporan";
    },
    labelButton() {
      return this.idLaporan != null ? "Edit" : "Submit";
    },
    formatLaporan() {
      return "<p style='text-align: center;'>LAPORAN / BERITA ACARA</p><p style='text-align: center;'>PENYERAHAN DAN PENYEMBELIHAN</p><p style='text-align: center;'>HEWAN QURBAN 1443 H./ 2022 M.</p><table border='1' cellpadding='2' cellspacing='0'><tbody><tr><td><p>Deskripsi Kegiatan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan deskripsi kegiatan)</span></i></em></p></td></tr><tr><td><p>Program</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan judul program)</span></i></em></p></td></tr><tr><td><p>Hari/Tgl Pelaksanaan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan tanggal pelaksanaan qurban)</span></i></em></p></td></tr><tr><td><p>Lokasi Pelaksanaan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan lokasi pelaksanaan qurban)</span></i></em></p></td></tr><tr><td><p>Alamat</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan alamat detail dari lokasi pelaksanaan qurban)</span></i></em></p></td></tr><tr><td><p>Koordinator Lokal</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan nama koordinator lokal dari pelaksanaan qurban)</span></i></em></p></td></tr><tr><td><p>Nomor HP</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan nomor telp/hp dari koordinator lokal)</span></i></em></p></td></tr><tr><td><p>Jumlah/Jenis Hewan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan jumlah hewan dan jenis hewan, contoh : 1/Kambing)</span></i></em></p></td></tr><tr><td><p>Jumlah PM</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan jumlah penerima manfaat)</span></i></em></p></td></tr><tr><td><p>Dokumentasi Penerimaan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan foto/video kegiatan penerimaan hewan qurban oleh penyembelih)</span></i></em></p></td></tr><tr><td><p>Dokumentasi Pemotongan</p></td><td><p>&nbsp;:</p></td><td><p><em><i><span>(Isi dengan foto/video kegiatan penyembelihan hewan qurban)</span></i></em></p></td></tr><tr><td><p>Dokumentasi Distribusi</p></td><td><p>:&nbsp;</p></td><td><p><em><i><span>(Isi dengan foto/video kegiatan pendistrbusian daging ke para penerima manfaat)</span></i></em></p></td></tr></tbody></table>";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.file !== "" &&
        this.formData.description !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
    laporans() {
      return this.search === ""
        ? this.itemEdit.laporan.reverse()
        : this.itemEdit.laporan.filter((v) => v.name === this.search).reverse();
    },
  },
  watch: {
    // search() {
    //   if (this.search !== "" || this.search !== null) {
    //     this.laporans(this.search);
    //   } else {
    //     this.laporans;
    //   }
    // },
  },
  methods: {
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    // laporans(search) {
    //   return search === null
    //     ? this.itemEdit.laporan
    //     : this.itemEdit.laporan.filter((v) => v.name == search);
    // },
    openEdit(val) {
      this.formData.name = val.name;
      this.formData.description = this.richtTextFormat(val.description);
      this.formData.file = val.file;
      this.idLaporan = val.id;
    },
    closeEdit() {
      this.formData.name = "";
      this.formData.description = "";
      this.formData.file = this.emptyImage;
      this.idLaporan = null;
    },
    // dialogDelete(id, name) {
    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "danger",
    //     title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
    //     text:
    //       name && id
    //         ? `Anda yakin ingin menghapus item ${name}`
    //         : "Anda yakin ingin menghapus item yang terpilih",
    //     accept: () => {
    //       if (name && id) {
    //         this.delete(id);
    //       } else {
    //         // eslint-disable-next-line no-lonely-if
    //         if (this.selected.length === 0) {
    //           this.$vs.notify({
    //             title: "Tidak ada item yang dipilih",
    //             text: "Pilihlah salah satu item atau semua item",
    //             color: "danger",
    //             position: "top-right",
    //           });
    //         } else {
    //           // eslint-disable-next-line prefer-const
    //           for (let i in this.selected) {
    //             this.delete(this.selected[i].id);
    //           }
    //         }
    //       }
    //     },
    //   });
    // },
    deleteItem(id) {
      this.$vs.loading({
        container: this.$refs.loadLaporan,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("qurban/cudLaporan", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Laporan ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getKodeQurban(this.itemEdit.id);
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => this.$vs.loading.close(this.$refs.loadLaporan));
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      if (this.binaryFile === "") {
        this.addDataLaporan();
      } else {
        this.addLaporanWithFile();
      }
    },
    addLaporanWithFile() {
      this.$store
        .dispatch("file/addFile", this.binaryFile)
        .then((v) => {
          this.formData.file = v.link;
          this.addDataLaporan();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.binaryFile = "";
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getKodeQurban(id) {
      this.$store
        .dispatch("qurban/getQurbanById", this.passData.id)
        .then((v) => {
          if (id !== null) {
            this.itemEdit = v.kode_qurban.find((v) => v.id == id);
          }
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addDataLaporan() {
      let id = {};
      if (this.idLaporan !== null) {
        id = {
          id: this.idLaporan.toString(),
        };
      }

      if (this.formData.file === this.emptyImage) {
        this.formData.file = "";
      }

      this.formData.kode_id = this.itemEdit.id.toString();
      this.$store
        .dispatch("qurban/cudLaporan", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.idLaporan !== null ? "Edit Qurban Sukses!" : "Tambah Qurban Sukses!",
            text:
              this.idLaporan !== null
                ? `Laporan Qurban ${v.name} Berhasil diedit`
                : `Laporan Qurban ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
        })
        .catch((e) => {
          this.$vs.loading.close();

          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.closeEdit();
          this.getKodeQurban(this.itemEdit.id);
        });
    },
  },
  mounted() {
    // this.getData();
  },
  created() {
    // if (this.$store.state.auth.profileAccess !== null) {
    //   if (
    //     this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/sub-kategori-campaign"
    //     )
    //   ) {
    //     this.access = this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/sub-kategori-campaign"
    //     );
    //   }
    // }
  },
};
</script>

<style scoped>
.imgTbl {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
.cover-hight {
  max-height: 450px;
}
</style>
